module.exports = __webpack_public_path__ + "static/cocogothic-bolditalic-webfont-9433d5861278e8fa00f58928b963e1c4.woff2";